import React, { useState } from "react";
import { FormGroup, Input, Label, Badge, Row, Col } from "reactstrap";
import { Key } from "lucide-react";

export default function FormPreview({ fields }) {
  const [values, setValues] = useState({});

  const handleChange = (id, value) => {
    setValues((prev) => ({ ...prev, [id]: value }));
  };

  return (
    <div className="fp-live-wrap">
      {fields.length === 0 && (
        <div className="fp-empty-state">
          <p className="text-muted small mb-0">Add fields to the canvas to see a preview</p>
        </div>
      )}

      {fields.map((f) => {
        const fieldId = f.id;
        const isFixed =
          f.fixedValueEnabled === true &&
          f.fixedValue != null &&
          f.fixedValue !== "";
        const fixedVal = isFixed ? f.fixedValue : "";
        const isReadOnly = f.readOnly === true || isFixed;
        const currentValue = isFixed ? fixedVal : values[fieldId] ?? "";

        const commonProps = {
          id: fieldId,
          readOnly: isReadOnly,
          disabled: isReadOnly,
          value: currentValue,
          onChange: (e) => handleChange(fieldId, e.target.value),
          bsSize: "sm",
        };
        const readOnlyClass = isReadOnly ? "fp-input-locked" : "";

        return (
          <FormGroup key={f.id} className="mb-3">
            <div className="d-flex align-items-center gap-2 mb-1 flex-wrap">
              <Label className="fp-field-label mb-0">
                {f.label}
                {(f.required || f.mandatory) && (
                  <span className="text-danger ms-1">*</span>
                )}
              </Label>
              {f.isSearchKey && (
                <Badge
                  color="success"
                  className="d-inline-flex align-items-center gap-1 py-1 px-2"
                >
                  <Key size={10} /> Search Key
                </Badge>
              )}
              {isFixed && (
                <Badge color="secondary" pill className="py-1 px-2" style={{ fontSize: "0.68rem" }}>
                  Fixed
                </Badge>
              )}
              {isReadOnly && !isFixed && (
                <Badge color="light" pill className="py-1 px-2 text-muted border" style={{ fontSize: "0.68rem" }}>
                  Read-only
                </Badge>
              )}
            </div>

            {["text", "email"].includes(f.type) && (
              <Input
                {...commonProps}
                type={f.type}
                className={readOnlyClass}
                placeholder={isReadOnly ? "" : f.placeholder || ""}
              />
            )}

            {f.type === "phone" && (
              <Input
                {...commonProps}
                type="text"
                inputMode="numeric"
                maxLength={10}
                className={`no-spinner ${readOnlyClass}`}
                placeholder={isReadOnly ? "" : f.placeholder || ""}
              />
            )}

            {["number", "amount"].includes(f.type) && (
              <Input
                {...commonProps}
                type="number"
                className={readOnlyClass}
                placeholder={isReadOnly ? "" : f.placeholder || ""}
              />
            )}

            {f.type === "textarea" && (
              <Input
                {...commonProps}
                type="textarea"
                rows={3}
                className={readOnlyClass}
                placeholder={isReadOnly ? "" : f.placeholder || ""}
              />
            )}

            {f.type === "date" && (
              <Input {...commonProps} type="date" className={readOnlyClass} />
            )}

            {f.type === "address" && (
  <Input
    {...commonProps}
    type="textarea"
    rows={3}
    className={readOnlyClass}
    placeholder={isReadOnly ? "" : f.placeholder || "Enter address"}
  />
)}


            {f.type === "select" && (
              <Input
                {...commonProps}
                type="select"
                className={readOnlyClass}
                value={currentValue}
              >
                {!isFixed && <option value="">Select…</option>}
                {(f.options || []).map((opt, i) => (
                  <option key={i} value={opt}>
                    {opt}
                  </option>
                ))}
              </Input>
            )}

            {f.type === "dropdown" && (
              <Input
                {...commonProps}
                type="select"
                className={readOnlyClass}
                value={currentValue}
              >
                {!isFixed && <option value="">Select…</option>}
                {(f.options || []).map((opt, i) => (
                  <option key={i} value={opt}>
                    {opt}
                  </option>
                ))}
              </Input>
            )}

            {f.type === "checkbox" && (
              <div className="form-check mt-1">
                <Input
                  id={fieldId}
                  type="checkbox"
                  className="form-check-input"
                  disabled={isReadOnly}
                  checked={
                    isFixed
                      ? fixedVal === "true" || fixedVal === true
                      : values[fieldId] || false
                  }
                  onChange={(e) => handleChange(fieldId, e.target.checked)}
                />
                <Label check htmlFor={fieldId} className="form-check-label">
                  {f.label}
                </Label>
              </div>
            )}

            {f.type === "radio" &&
              (f.options || []).map((opt, i) => (
                <FormGroup check key={i} className="mb-1">
                  <Input
                    name={f.name || fieldId}
                    type="radio"
                    id={`${fieldId}-${i}`}
                    disabled={isReadOnly}
                    checked={
                      isFixed ? fixedVal === opt : values[fieldId] === opt
                    }
                    onChange={() => handleChange(fieldId, opt)}
                  />
                  <Label check htmlFor={`${fieldId}-${i}`}>
                    {opt}
                  </Label>
                </FormGroup>
              ))}

            {f.help && (
              <small className="text-muted d-block mt-1">{f.help}</small>
            )}
          </FormGroup>
        );
      })}
    </div>
  );
}